import {
  $deleteGridItems,
  $emptyTrash,
  $getGrid,
  $getGridForSignatureRequests,
  $moveToTrashGridItems,
  $updateGrid,
  deleteGridItems,
  emptyTrash,
  getGrid,
  getGridForSignatureRequests,
  moveToTrashGridItems,
  updateGrid,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    getGrid,
    updateGrid,
    deleteGridItems,
    getGridForSignatureRequests,
    moveToTrashGridItems,
    emptyTrash,
  },
};

export const $actions = {
  getGrid: $getGrid,
  updateGrid: $updateGrid,
  deleteGridItems: $deleteGridItems,
  getGridForSignatureRequests: $getGridForSignatureRequests,
  moveToTrashGridItems: $moveToTrashGridItems,
  emptyTrash: $emptyTrash,
};
